import {Layout} from '@components/layout/index';
import {fixPropsForJson} from '@helpers/common/json.mjs';
import {
  getCustomCollectionPageData,
  getCustomCollectionPageProductDataBySkuList
} from '@helpers/collections/collection-page-product-data.mjs';
import {CustomCollectionComponent} from '@components/collections/custom-collections/CustomCollectionComponent';
import {handleCollectionPageFilterChange} from '@components/collections/FilteringSidebar';
import {getServerSession} from 'next-auth/next';
import {authOptions} from '../api/auth/[...nextauth]';
import {normalizeReqSessionData} from '@components/ip-address/session-data.mjs';

export const getServerSideProps = async ({req, res}) => {
  let session = await getServerSession(req, res, authOptions(req, res));
  session = normalizeReqSessionData(req, res, session);

  const collectionPath = '/professional-audio';
  const productCategory = 'professional-audio';

  const skuList = ['SK-PRX12A', 'SK-PRX8A', 'SK-PRX10A'];

  const [collectionPageInfo, collectionProducts] = await Promise.all([
    getCustomCollectionPageData(collectionPath),
    getCustomCollectionPageProductDataBySkuList(skuList)
  ]);

  return {
    props: {
      disableMobileNav: true,
      showCountdownTimerMobile: false,
      collectionPageInfo: collectionPageInfo,
      products: fixPropsForJson(collectionProducts),
      session: session
    }
  };
};

export default function ProfessionalAudioCollectionPage({products, collectionPageInfo, session}) {
  return (
    <>
      <CustomCollectionComponent
        products={products}
        collectionPageInfo={collectionPageInfo}
        handleFilterChange={handleCollectionPageFilterChange}
        session={session}
      />
    </>
  );
}

ProfessionalAudioCollectionPage.Layout = Layout;
